import { Api } from "@mcleod/core";
import { AutogenLayoutCashedChecksHistoryReport } from "./autogen/AutogenLayoutCashedChecksHistoryReport";

export class CashedChecksHistoryReport extends AutogenLayoutCashedChecksHistoryReport {
  
    override async onLoad(): Promise<void> {
        this.textboxCardProvider.visible = false;
        const response = await Api.search("lme/dispatch/asset/fuel-interface-configured", {});

        this.textboxCardProvider.visible = response.data.length >= 2;
        if (response.actual_row_count === 1) {
            this.textboxCardProvider.required = false;
            this.textboxCardProvider.requiredDuringSearch = false;
            this.textboxCardProvider.visible = false;
            const data = response?.data?.[0];
        }
    }



    
}

 


